module.exports = __webpack_public_path__ + "static/img/li7_3.eee27833.png";